import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "Turborepo 2.2",
  "description": "Turborepo 2.2는 저장소를 쿼리하는 새로운 명령, 캐시 안전성 개선 및 지능형 영향을 받은 필터를 추가합니다.",
  "date": "2024/10/18",
  "tag": "web development"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Turborepo 2.2는 새로운 저장소 쿼리 명령과 함께 다른 개선 사항을 제공합니다:"
  }, {
    "heading": "",
    "content": "저장소 쿼리 : turbo query로 이전에 없던 방식으로 저장소 탐색"
  }, {
    "heading": "",
    "content": "개선된 캐시 안전성: 누락된 환경 변수 의존성 및 잘못된 캐시 구성을 쉽게 진단하고 수정"
  }, {
    "heading": "",
    "content": "영향을 받은 패키지에 대한 무구성 비교: GitHub 워크플로우에서 변경 사항이 있는 패키지를 자동으로 타겟팅"
  }, {
    "heading": "",
    "content": "npx @turbo/codemod migrate를 실행하여 지금 업데이트하거나 npx create-turbo@latest로 시작하세요."
  }, {
    "heading": "저장소-쿼리-experimental",
    "content": "Turborepo 2.2에서 Turborepo의 저장소 데이터에 대해 GraphQL 쿼리를 실행할 수 있는 새로운 명령인 turbo query를 소개합니다. Turborepo는 최대 효율성으로 작업을 실행하기 위해 저장소에 대한 많은 데이터를 계산합니다. 여기에는 패키지 의존성 그래프, 변경된 패키지, 작업 의존성, 작업의 로그 출력 등이 포함됩니다.\n이 데이터는 스크립팅, 리팩토링, CI에서 실행할 항목 결정 및 코드베이스에 대한 다른 인사이트 발견에 유용할 수 있습니다."
  }, {
    "heading": "저장소-쿼리-experimental",
    "content": "시작하려면 turbo query를 실행하여 GraphiQL을 엽니다. 이는 대화형 스키마 탐색, 문서화 및 쿼리 전송을 지원하는 GraphQL 쿼리 작성용 로컬 IDE입니다."
  }, {
    "heading": "저장소-쿼리-experimental",
    "content": "쿼리를 문자열 또는 파일 경로로 직접 전달할 수도 있습니다:"
  }, {
    "heading": "예제",
    "content": "test 작업이 있는 모든 영향을 받은 패키지의 이름과 경로를 가져옵니다."
  }, {
    "heading": "예제",
    "content": "특정 패키지와 그 직접 의존성을 가져옵니다."
  }, {
    "heading": "예제",
    "content": "직접 종속자가 10개를 초과하는 모든 패키지를 찾습니다."
  }, {
    "heading": "예제",
    "content": "Turborepo는 과거에 실행 요약, 드라이 런 및 ls와 같은 구조화된 데이터용 API를 추가했습니다.\n그러나 이러한 API에는 몇 가지 제한 사항이 있습니다. 첫째, 일반 저장소 정보가 아닌 단일 실행을 중심으로 합니다. 둘째, 더 많은 필드를 추가함에 따라 출력이 매우 커졌습니다.\n실행에 구애받지 않는 방식으로 저장소 데이터를 쿼리하고 반환되는 데이터를 더 사용자 정의할 수 있는 방법이 필요했습니다."
  }, {
    "heading": "예제",
    "content": "이 새로운 실험적 기능에 대한 초기 피드백을 제공해 준 @maschwenk, @rafaeltab 및 @weyert에게 감사드립니다."
  }, {
    "heading": "예제",
    "content": "자세한 내용은 문서를 방문하세요. 이 새로운 실험적 명령에 대한 피드백은 turbo query RFC에 남겨주세요."
  }, {
    "heading": "개선된-캐시-안전성",
    "content": "작업 캐싱은 Turborepo의 가장 강력한 기능 중 하나로, 변경된 것만 다시 실행하여 빌드 및 기타 작업 속도를 높입니다.\nTurborepo 2.2에서는 캐시 입력 및 출력을 구성하고 올바르지 않아 보일 때 경고하는 몇 가지 개선 사항을 출시합니다."
  }, {
    "heading": "플랫폼-환경-변수",
    "content": "애플리케이션을 배포할 때 프로덕션 환경에 이미 환경 변수가 구성되어 있을 것입니다. 이제 지원되는 플랫폼의 경우 Turborepo가\n이러한 환경 변수를 turbo.json 구성과 자동으로 확인하여 올바르게 고려했는지 확인하고,\n누락된 환경 변수에 대해 경고합니다."
  }, {
    "heading": "플랫폼-환경-변수",
    "content": "모든 플랫폼은 빌드 환경에 TURBO_PLATFORM_ENV 환경 변수를 구현하여 이 기능을 지원할 수 있습니다."
  }, {
    "heading": "플랫폼-환경-변수",
    "content": "Vercel이 오늘 지원되며, 더 많은 플랫폼을 사용할 수 있게 되면 문서를 업데이트할 예정입니다."
  }, {
    "heading": "플랫폼-환경-변수",
    "content": "플랫폼 환경 변수에 대해 자세히 알아보세요."
  }, {
    "heading": "빈-캐시-구성에-대한-경고",
    "content": "작업을 실행할 때 Turborepo는 이제 작업이 빈 디렉토리를 캐시하도록 구성된 경우 경고합니다.\n이는 일반적인 실수일 수 있으며 우발적인 빌드 중단으로 이어질 수 있습니다. 이는 2.2에서 기본적으로 활성화됩니다."
  }, {
    "heading": "빈-캐시-구성에-대한-경고",
    "content": "출력 구성에 대해 자세히 알아보세요."
  }, {
    "heading": "eslint-config-turbo-개선",
    "content": "Turborepo는 일반 프레임워크에 대해 환경 키에 접두사 와일드카드를 자동으로 추가합니다.\n지원되는 프레임워크 중 하나를 사용하는 경우 프레임워크의 접두사로 시작하는 환경 변수를 지정할 필요가 없습니다."
  }, {
    "heading": "eslint-config-turbo-개선",
    "content": "이제 Turborepo 2.2에서 eslint-config-turbo도 이 기능을 지원하여 플러그인의 경고가 정확하고 실행 가능하도록 합니다."
  }, {
    "heading": "eslint-config-turbo-개선",
    "content": "eslint-config-turbo에 대해 자세히 알아보세요."
  }, {
    "heading": "--affected를-사용한-무구성-비교",
    "content": "Turborepo 2.1에서 turbo run 및 turbo ls와 함께 사용하여 변경된 패키지를 자동으로 타겟팅할 수 있는 --affected 플래그를 출시했습니다.\n2.2에서는 GitHub 워크플로우에서 --affected를 실행할 때 자동 비교를 도입하여 일반적인 사용 사례를 더욱 스마트하게 만들어 한 단계 더 나아갑니다."
  }, {
    "heading": "--affected를-사용한-무구성-비교",
    "content": "pull request에 대한 응답으로 실행되는 워크플로우의 경우 비교의 기준이 pull request의 기준으로 자동 설정됩니다. 이를 통해 turbo가 영향을 받은 패키지를 결정할 때 pull request에서 변경된 모든 파일을 고려합니다."
  }, {
    "heading": "--affected를-사용한-무구성-비교",
    "content": "push에 대한 응답으로 실행되는 워크플로우의 경우 비교의 기준이 최신 push 이전의 커밋으로 자동 설정됩니다."
  }, {
    "heading": "--affected를-사용한-무구성-비교",
    "content": "--affected에 대해 자세히 알아보세요."
  }, {
    "heading": "커뮤니티",
    "content": "Turborepo 2.1 출시 이후 놀라운 채택과 커뮤니티 성장을 보았습니다:"
  }, {
    "heading": "커뮤니티",
    "content": "26.2k+ GitHub Stars"
  }, {
    "heading": "커뮤니티",
    "content": "3.2M+ 주간 NPM 다운로드"
  }, {
    "heading": "커뮤니티",
    "content": "Vercel의 Remote Caching을 통해 477년의 컴퓨팅 시간 절약"
  }, {
    "heading": "커뮤니티",
    "content": "Turborepo는 핵심 팀을 포함한 모든 기여자들의 결합된 작업의 결과입니다."
  }, {
    "heading": "커뮤니티",
    "content": "전체 변경 로그를 확인하세요."
  }, {
    "heading": "커뮤니티",
    "content": "Turborepo를 여러분의 빌드 도구로 만들어 주시는 지속적인 지원, 피드백 및 협력에 감사드립니다."
  }],
  "headings": [{
    "id": "저장소-쿼리-experimental",
    "content": "저장소 쿼리 Experimental"
  }, {
    "id": "예제",
    "content": "예제"
  }, {
    "id": "개선된-캐시-안전성",
    "content": "개선된 캐시 안전성"
  }, {
    "id": "플랫폼-환경-변수",
    "content": "플랫폼 환경 변수"
  }, {
    "id": "빈-캐시-구성에-대한-경고",
    "content": "빈 캐시 구성에 대한 경고"
  }, {
    "id": "eslint-config-turbo-개선",
    "content": "eslint-config-turbo 개선"
  }, {
    "id": "--affected를-사용한-무구성-비교",
    "content": "--affected를 사용한 무구성 비교"
  }, {
    "id": "커뮤니티",
    "content": "커뮤니티"
  }]
};
import {Authors} from '#components/authors';
import {Date} from '#components/blog/date';
import {Callout} from '#components/callout';
import {ExperimentalBadge} from '#components/experimental-badge';
export const toc = [{
  depth: 2,
  url: "#저장소-쿼리-experimental",
  title: _jsxs(_Fragment, {
    children: ["저장소 쿼리 ", _jsx(ExperimentalBadge, {
      children: "Experimental"
    })]
  })
}, {
  depth: 3,
  url: "#예제",
  title: _jsx(_Fragment, {
    children: "예제"
  })
}, {
  depth: 2,
  url: "#개선된-캐시-안전성",
  title: _jsx(_Fragment, {
    children: "개선된 캐시 안전성"
  })
}, {
  depth: 3,
  url: "#플랫폼-환경-변수",
  title: _jsx(_Fragment, {
    children: "플랫폼 환경 변수"
  })
}, {
  depth: 3,
  url: "#빈-캐시-구성에-대한-경고",
  title: _jsx(_Fragment, {
    children: "빈 캐시 구성에 대한 경고"
  })
}, {
  depth: 3,
  url: "#eslint-config-turbo-개선",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "eslint-config-turbo"
    }), " 개선"]
  })
}, {
  depth: 2,
  url: "#--affected를-사용한-무구성-비교",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "--affected"
    }), "를 사용한 무구성 비교"]
  })
}, {
  depth: 2,
  url: "#커뮤니티",
  title: _jsx(_Fragment, {
    children: "커뮤니티"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    h3: "h3",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx("h1", {
      className: "text-center",
      children: "Turborepo 2.2"
    }), "\n", "\n", _jsx(Date, {
      children: "Friday, October 18th, 2024"
    }), "\n", _jsx(Authors, {
      authors: ['tomknickman', 'anthonyshew', 'chrisolszewski', 'nicholasyang', 'dimitrimitropoulos']
    }), "\n", _jsx(_components.p, {
      children: "Turborepo 2.2는 새로운 저장소 쿼리 명령과 함께 다른 개선 사항을 제공합니다:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsxs(_components.a, {
          href: "#query-your-repository-experimental",
          children: [_jsx(_components.strong, {
            children: "저장소 쿼리"
          }), " ", _jsx(ExperimentalBadge, {
            isLink: false
          })]
        }), ": ", _jsx(_components.code, {
          children: "turbo query"
        }), "로 이전에 없던 방식으로 저장소 탐색"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#improved-cache-safety",
          children: _jsx(_components.strong, {
            children: "개선된 캐시 안전성"
          })
        }), ": 누락된 환경 변수 의존성 및 잘못된 캐시 구성을 쉽게 진단하고 수정"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#zero-configuration-comparisons-with---affected",
          children: _jsx(_components.strong, {
            children: "영향을 받은 패키지에 대한 무구성 비교"
          })
        }), ": GitHub 워크플로우에서 변경 사항이 있는 패키지를 자동으로 타겟팅"]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "npx @turbo/codemod migrate"
      }), "를 실행하여 지금 업데이트하거나 ", _jsx(_components.code, {
        children: "npx create-turbo@latest"
      }), "로 시작하세요."]
    }), "\n", _jsxs(_components.h2, {
      id: "저장소-쿼리-experimental",
      children: ["저장소 쿼리 ", _jsx(ExperimentalBadge, {
        children: "Experimental"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo 2.2에서 Turborepo의 저장소 데이터에 대해 ", _jsx(_components.a, {
        href: "https://graphql.org/",
        children: "GraphQL"
      }), " 쿼리를 실행할 수 있는 새로운 명령인 ", _jsx(_components.a, {
        href: "/docs/reference/query",
        children: _jsx(_components.code, {
          children: "turbo query"
        })
      }), "를 소개합니다. Turborepo는 최대 효율성으로 작업을 실행하기 위해 저장소에 대한 많은 데이터를 계산합니다. 여기에는 패키지 의존성 그래프, 변경된 패키지, 작업 의존성, 작업의 로그 출력 등이 포함됩니다.\n이 데이터는 스크립팅, 리팩토링, CI에서 실행할 항목 결정 및 코드베이스에 대한 다른 인사이트 발견에 유용할 수 있습니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["시작하려면 ", _jsx(_components.code, {
        children: "turbo query"
      }), "를 실행하여 GraphiQL을 엽니다. 이는 대화형 스키마 탐색, 문서화 및 쿼리 전송을 지원하는 GraphQL 쿼리 작성용 로컬 IDE입니다."]
    }), "\n", _jsx(_components.p, {
      children: "쿼리를 문자열 또는 파일 경로로 직접 전달할 수도 있습니다:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " query"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"query { package(name: \\\"web\\\") { name } }\""
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " query"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " query.gql"
            })]
          })]
        })
      })
    }), "\n", _jsx(_components.h3, {
      id: "예제",
      children: "예제"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "test"
      }), " 작업이 있는 모든 ", _jsx(_components.a, {
        href: "/docs/reference/run#--affected",
        children: "영향을 받은 패키지"
      }), "의 이름과 경로를 가져옵니다."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "affected-packages.gql",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M12.002 0a2.138 2.138 0 1 0 0 4.277 2.138 2.138 0 1 0 0-4.277zm8.54 4.931a2.138 2.138 0 1 0 0 4.277 2.138 2.138 0 1 0 0-4.277zm0 9.862a2.138 2.138 0 1 0 0 4.277 2.138 2.138 0 1 0 0-4.277zm-8.54 4.931a2.138 2.138 0 1 0 0 4.276 2.138 2.138 0 1 0 0-4.276zm-8.542-4.93a2.138 2.138 0 1 0 0 4.276 2.138 2.138 0 1 0 0-4.277zm0-9.863a2.138 2.138 0 1 0 0 4.277 2.138 2.138 0 1 0 0-4.277zm8.542-3.378L2.953 6.777v10.448l9.049 5.224 9.047-5.224V6.777zm0 1.601 7.66 13.27H4.34zm-1.387.371L3.97 15.037V7.363zm2.774 0 6.646 3.838v7.674zM5.355 17.44h13.293l-6.646 3.836z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  affectedPackages("
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    base: "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"main\""
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    head: "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"HEAD\""
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    filter: { "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: "has"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: ": { "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: "field"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: ": TASK_NAME, "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: "value"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: ": "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"test\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " } }"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  ) {"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    items {"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "      name"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "      path"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "특정 패키지와 그 직접 의존성을 가져옵니다."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "direct-dependencies.gql",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M12.002 0a2.138 2.138 0 1 0 0 4.277 2.138 2.138 0 1 0 0-4.277zm8.54 4.931a2.138 2.138 0 1 0 0 4.277 2.138 2.138 0 1 0 0-4.277zm0 9.862a2.138 2.138 0 1 0 0 4.277 2.138 2.138 0 1 0 0-4.277zm-8.54 4.931a2.138 2.138 0 1 0 0 4.276 2.138 2.138 0 1 0 0-4.276zm-8.542-4.93a2.138 2.138 0 1 0 0 4.276 2.138 2.138 0 1 0 0-4.277zm0-9.863a2.138 2.138 0 1 0 0 4.277 2.138 2.138 0 1 0 0-4.277zm8.542-3.378L2.953 6.777v10.448l9.049 5.224 9.047-5.224V6.777zm0 1.601 7.66 13.27H4.34zm-1.387.371L3.97 15.037V7.363zm2.774 0 6.646 3.838v7.674zM5.355 17.44h13.293l-6.646 3.836z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "query"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  package(name: "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"cli\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: ") {"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    directDependencies {"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "      name"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "직접 종속자가 10개를 초과하는 모든 패키지를 찾습니다."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "filter.gql",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M12.002 0a2.138 2.138 0 1 0 0 4.277 2.138 2.138 0 1 0 0-4.277zm8.54 4.931a2.138 2.138 0 1 0 0 4.277 2.138 2.138 0 1 0 0-4.277zm0 9.862a2.138 2.138 0 1 0 0 4.277 2.138 2.138 0 1 0 0-4.277zm-8.54 4.931a2.138 2.138 0 1 0 0 4.276 2.138 2.138 0 1 0 0-4.276zm-8.542-4.93a2.138 2.138 0 1 0 0 4.276 2.138 2.138 0 1 0 0-4.277zm0-9.863a2.138 2.138 0 1 0 0 4.277 2.138 2.138 0 1 0 0-4.277zm8.542-3.378L2.953 6.777v10.448l9.049 5.224 9.047-5.224V6.777zm0 1.601 7.66 13.27H4.34zm-1.387.371L3.97 15.037V7.363zm2.774 0 6.646 3.838v7.674zM5.355 17.44h13.293l-6.646 3.836z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "query"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  packages("
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    filter: { "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: "greaterThan"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: ": { "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: "field"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: ": DIRECT_DEPENDENT_COUNT, "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: "value"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: ": "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: "10"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " } }"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  ) {"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    name"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo는 과거에 ", _jsx(_components.a, {
        href: "/docs/reference/run#--summarize",
        children: "실행 요약"
      }), ", ", _jsx(_components.a, {
        href: "/docs/reference/run#--dry----dry-run",
        children: "드라이 런"
      }), " 및 ", _jsx(_components.a, {
        href: "/docs/reference/ls",
        children: _jsx(_components.code, {
          children: "ls"
        })
      }), "와 같은 구조화된 데이터용 API를 추가했습니다.\n그러나 이러한 API에는 몇 가지 제한 사항이 있습니다. 첫째, 일반 저장소 정보가 아닌 단일 실행을 중심으로 합니다. 둘째, 더 많은 필드를 추가함에 따라 출력이 매우 커졌습니다.\n실행에 구애받지 않는 방식으로 저장소 데이터를 쿼리하고 반환되는 데이터를 더 사용자 정의할 수 있는 방법이 필요했습니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["이 새로운 실험적 기능에 대한 초기 피드백을 제공해 준 ", _jsx(_components.a, {
        href: "https://github.com/maschwenk",
        children: "@maschwenk"
      }), ", ", _jsx(_components.a, {
        href: "https://github.com/rafaeltab",
        children: "@rafaeltab"
      }), " 및 ", _jsx(_components.a, {
        href: "https://github.com/weyert",
        children: "@weyert"
      }), "에게 감사드립니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["자세한 내용은 ", _jsx(_components.a, {
        href: "/docs/reference/query",
        children: "문서를 방문하세요"
      }), ". 이 새로운 실험적 명령에 대한 피드백은 ", _jsx(_components.code, {
        children: "turbo query"
      }), " ", _jsx(_components.a, {
        href: "https://github.com/vercel/turborepo/discussions/9170",
        children: "RFC"
      }), "에 남겨주세요."]
    }), "\n", _jsx(_components.h2, {
      id: "개선된-캐시-안전성",
      children: "개선된 캐시 안전성"
    }), "\n", _jsx(_components.p, {
      children: "작업 캐싱은 Turborepo의 가장 강력한 기능 중 하나로, 변경된 것만 다시 실행하여 빌드 및 기타 작업 속도를 높입니다.\nTurborepo 2.2에서는 캐시 입력 및 출력을 구성하고 올바르지 않아 보일 때 경고하는 몇 가지 개선 사항을 출시합니다."
    }), "\n", _jsx(_components.h3, {
      id: "플랫폼-환경-변수",
      children: "플랫폼 환경 변수"
    }), "\n", _jsxs(_components.p, {
      children: ["애플리케이션을 배포할 때 프로덕션 환경에 이미 환경 변수가 구성되어 있을 것입니다. 이제 지원되는 플랫폼의 경우 Turborepo가\n이러한 환경 변수를 ", _jsx(_components.code, {
        children: "turbo.json"
      }), " 구성과 자동으로 확인하여 ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/using-environment-variables#adding-environment-variables-to-task-hashes",
        children: "올바르게 고려했는지"
      }), " 확인하고,\n누락된 환경 변수에 대해 경고합니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["모든 플랫폼은 빌드 환경에 ", _jsx(_components.a, {
        href: "/docs/reference/system-environment-variables",
        children: _jsx(_components.code, {
          children: "TURBO_PLATFORM_ENV"
        })
      }), " 환경 변수를 구현하여 이 기능을 지원할 수 있습니다."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "https://vercel.com",
        children: "Vercel"
      }), "이 오늘 지원되며, 더 많은 플랫폼을 사용할 수 있게 되면 문서를 업데이트할 예정입니다."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "/docs/crafting-your-repository/using-environment-variables#platform-environment-variables",
        children: "플랫폼 환경 변수"
      }), "에 대해 자세히 알아보세요."]
    }), "\n", _jsx(_components.h3, {
      id: "빈-캐시-구성에-대한-경고",
      children: "빈 캐시 구성에 대한 경고"
    }), "\n", _jsx(_components.p, {
      children: "작업을 실행할 때 Turborepo는 이제 작업이 빈 디렉토리를 캐시하도록 구성된 경우 경고합니다.\n이는 일반적인 실수일 수 있으며 우발적인 빌드 중단으로 이어질 수 있습니다. 이는 2.2에서 기본적으로 활성화됩니다."
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "/docs/crafting-your-repository/configuring-tasks#specifying-outputs",
        children: "출력 구성"
      }), "에 대해 자세히 알아보세요."]
    }), "\n", _jsxs(_components.h3, {
      id: "eslint-config-turbo-개선",
      children: [_jsx(_components.code, {
        children: "eslint-config-turbo"
      }), " 개선"]
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo는 ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/using-environment-variables#framework-inference",
        children: "일반 프레임워크"
      }), "에 대해 환경 키에 접두사 와일드카드를 자동으로 추가합니다.\n지원되는 프레임워크 중 하나를 사용하는 경우 프레임워크의 접두사로 시작하는 환경 변수를 지정할 필요가 없습니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["이제 Turborepo 2.2에서 ", _jsx(_components.code, {
        children: "eslint-config-turbo"
      }), "도 이 기능을 지원하여 플러그인의 경고가 정확하고 실행 가능하도록 합니다."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "/docs/reference/eslint-config-turbo",
        children: _jsx(_components.code, {
          children: "eslint-config-turbo"
        })
      }), "에 대해 자세히 알아보세요."]
    }), "\n", _jsxs(_components.h2, {
      id: "--affected를-사용한-무구성-비교",
      children: [_jsx(_components.code, {
        children: "--affected"
      }), "를 사용한 무구성 비교"]
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo 2.1에서 ", _jsx(_components.a, {
        href: "/docs/reference/run",
        children: _jsx(_components.code, {
          children: "turbo run"
        })
      }), " 및 ", _jsx(_components.a, {
        href: "/docs/reference/ls",
        children: _jsx(_components.code, {
          children: "turbo ls"
        })
      }), "와 함께 사용하여 변경된 패키지를 자동으로 타겟팅할 수 있는 ", _jsx(_components.a, {
        href: "/docs/reference/run#--affected",
        children: _jsx(_components.code, {
          children: "--affected"
        })
      }), " 플래그를 출시했습니다.\n2.2에서는 GitHub 워크플로우에서 ", _jsx(_components.a, {
        href: "/docs/reference/run#--affected",
        children: _jsx(_components.code, {
          children: "--affected"
        })
      }), "를 실행할 때 자동 비교를 도입하여 일반적인 사용 사례를 더욱 스마트하게 만들어 한 단계 더 나아갑니다."]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "https://docs.github.com/en/actions/writing-workflows/choosing-when-your-workflow-runs/events-that-trigger-workflows#pull_request",
          children: "pull request"
        }), "에 대한 응답으로 실행되는 워크플로우의 경우 비교의 기준이 pull request의 기준으로 자동 설정됩니다. 이를 통해 ", _jsx(_components.code, {
          children: "turbo"
        }), "가 영향을 받은 패키지를 결정할 때 pull request에서 변경된 모든 파일을 고려합니다."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "https://docs.github.com/en/actions/writing-workflows/choosing-when-your-workflow-runs/events-that-trigger-workflows#push",
          children: "push"
        }), "에 대한 응답으로 실행되는 워크플로우의 경우 비교의 기준이 최신 push 이전의 커밋으로 자동 설정됩니다."]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "/docs/crafting-your-repository/constructing-ci#using---affected-in-github-actions",
        children: _jsx(_components.code, {
          children: "--affected"
        })
      }), "에 대해 자세히 알아보세요."]
    }), "\n", _jsx(_components.h2, {
      id: "커뮤니티",
      children: "커뮤니티"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "/blog/turbo-2-1-0",
        children: "Turborepo 2.1"
      }), " 출시 이후 놀라운 채택과 커뮤니티 성장을 보았습니다:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://github.com/vercel/turbo",
          children: "26.2k+ GitHub Stars"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://www.npmjs.com/package/turbo",
          children: "3.2M+ 주간 NPM 다운로드"
        })
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "https://vercel.com/docs/concepts/monorepos/remote-caching",
          children: "Vercel의 Remote Caching"
        }), "을 통해 477년의 컴퓨팅 시간 절약"]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "Turborepo는 핵심 팀을 포함한 모든 기여자들의 결합된 작업의 결과입니다."
    }), "\n", _jsxs(_components.p, {
      children: ["전체 ", _jsx(_components.a, {
        href: "https://github.com/vercel/turborepo/releases/tag/v2.2.0",
        children: "변경 로그"
      }), "를 확인하세요."]
    }), "\n", _jsx(_components.p, {
      children: "Turborepo를 여러분의 빌드 도구로 만들어 주시는 지속적인 지원, 피드백 및 협력에 감사드립니다."
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
